import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import classnames from 'classnames';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import qs from 'querystring';

import { buttons as Buttons } from '@breezeway/brzw-components';
import { filterTypeName } from '../../utils/url_filters';
import { useNewStyleGuide } from '../../../@internalStore/style_guide/selectors';

import './filter_checkbox.scss';

const {
  BUTTON_THEMES: { SECONDARY_GRAY },
  BUTTON_SIZES: { MEDIUM, LARGE },
} = Buttons.constants;

const makeOptions = types =>
  _.map(types, type =>
    _.isObject(type)
      ? { value: type.code || type.id, label: type.name || type.code }
      : { value: type, label: type },
  );

class FilterCheckbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
    };

    this.changePath = this.changePath.bind(this);
    this.clearSelections = this.clearSelections.bind(this);
    this.expand = this.expand.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.onChange = this.onChange.bind(this);
    this.renderFilterTrigger = this.renderFilterTrigger.bind(this);
    this.initUpdateWindowDimensions = this.onResize.bind(this);
    this.onResize = _.debounce(this.onResize.bind(this), 200);
  }

  componentWillMount() {
    document.addEventListener('mousedown', this.handleClick, false);
  }

  componentDidMount() {
    this.initUpdateWindowDimensions();
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false);
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    if (
      this.node &&
      _.get(this.node, 'getBoundingClientRect') &&
      _.get(this.node, 'parentElement.getBoundingClientRect')
    ) {
      const element = this.node;
      const parentPosition = element.parentElement.getBoundingClientRect();
      const dropDown = element.getElementsByClassName('dropdown-menu').item(0);
      const dropDownPosition = dropDown.getBoundingClientRect();
      if (parentPosition.right < dropDownPosition.right) {
        element.classList.add('-right');
      } else if (element.classList.contains('-right')) {
        element.classList.remove('-right');
      }
    }
  }

  onChange(option, value) {
    this.changePath(option, value);
    if (value) {
      this.props.onSet(option.value);
    } else {
      this.props.onClear(option.value);
    }
  }

  changePath(option, value) {
    const {
      history,
      name,
      location: { search, pathname },
    } = this.props;
    const query = qs.parse(_.replace(search, '?', ''));
    let queryName = query[name];

    if (queryName) {
      if (value) {
        queryName = `${queryName},${option.value.toString()}`;
      } else {
        queryName = filterTypeName(queryName, option.value);
      }
    } else {
      queryName = option.value.toString();
    }

    query[name] = queryName;
    history.push({
      search: qs.stringify(query),
      pathname,
    });
  }

  handleClick(e) {
    if (!_.isEmpty(this.node) && !this.node.contains(e.target)) {
      this.setState({ expanded: false });
    }
  }

  expand() {
    this.setState({ expanded: !this.state.expanded });
  }

  clearSelections() {
    return this.props.onClearAll();
  }

  renderFilterTrigger() {
    const { placeholder, mobile, useStyleGuide } = this.props;
    const { expanded } = this.state;

    const arrowClassName = classnames('dropdown-checkbox__suffix-decorator', {
      'dropdown-checkbox__suffix-decorator--active': expanded,
    });

    if (useStyleGuide) {
      return (
        <Buttons.IconTextButton
          autoWidth={!mobile}
          className={arrowClassName}
          iconNameRight="chevron-bold-down"
          onClick={this.expand}
          size={mobile ? LARGE : MEDIUM}
          theme={SECONDARY_GRAY}
        >
          {placeholder}
        </Buttons.IconTextButton>
      );
    }

    return (
      <Button
        className="dropdown-checkbox__btn d-flex align-items-center w-100"
        onClick={this.expand}
        color="transparent"
      >
        <div className="dropdown-checkbox__main-placeholder">
          <span className="dropdown-checkbox__prefix-decorator" />
          <div className={classnames('dropdown-checkbox__placeholder', { '-mobile': mobile })}>
            {placeholder}
          </div>
        </div>
        <span className={arrowClassName} />
      </Button>
    );
  }

  render() {
    const { counts, disabled, mobile, selected, size, types, useStyleGuide, right } = this.props;
    const { expanded } = this.state;

    const options = makeOptions(types);

    return (
      <div
        className={classnames('button-group dropdown-checkbox Select Select--multi', {
          '-mobile': mobile,
          '-style-guide': useStyleGuide,
          '-no-style-guide': !useStyleGuide,
        })}
        ref={node => {
          this.node = node;
        }}
      >
        <div className="dropdown-checkbox__container">
          {this.renderFilterTrigger()}

          <ul
            className={classnames('dropdown-menu dropdown-checkbox__menu', {
              [`-${size}`]: size,
              '-expanded': expanded,
              '-right': right,
            })}
          >
            <li className="dropdown-checkbox__list -clear">
              <Button color="link" onClick={this.clearSelections}>
                Clear All
              </Button>
            </li>
            {_.map(options, option => (
              <li className="dropdown-checkbox__list" key={option.value}>
                <label>
                  <input
                    checked={_.includes(selected, option.value)}
                    disabled={disabled}
                    onChange={e => this.onChange(option, e.target.checked)}
                    type="checkbox"
                  />
                  {option.label}
                  {_.get(counts, option.value, 0) > 0 && ` (${counts[option.value]})`}
                </label>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

FilterCheckbox.propTypes = {
  counts: PropTypes.shape({}),
  disabled: PropTypes.bool,
  history: PropTypes.shape({}),
  mobile: PropTypes.bool,
  name: PropTypes.string,
  onClear: PropTypes.func,
  onClearAll: PropTypes.func,
  onSet: PropTypes.func,
  placeholder: PropTypes.string,
  right: PropTypes.bool,
  location: PropTypes.shape({
    state: PropTypes.shape({}),
    pathname: PropTypes.string,
  }),
  selected: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  size: PropTypes.string,
  types: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  useStyleGuide: PropTypes.bool,
};

FilterCheckbox.defaultProps = {
  disabled: false,
};

const mapStateToProps = (state, props) => ({
  useStyleGuide: useNewStyleGuide(state, props.useNewStyleGuide),
});

const withConnect = connect(mapStateToProps);

export default compose(
  withConnect,
  withRouter,
)(FilterCheckbox);
